import { useQuery } from "@tanstack/react-query";
import { PartnerMigrationModel } from "api/client.generated";
import useApi from "../useApi";

interface UsePartnerMigrationReturn {
  migrationData: PartnerMigrationModel | undefined;
  isMigrationDataLoading: boolean;
}

const usePartnerMigration = (): UsePartnerMigrationReturn => {
  const { partnersMigrationClient } = useApi();

  const { data, isFetching } = useQuery({
    queryKey: ["getMigration"],
    queryFn: () => partnersMigrationClient.getMigration(),
    retry: false, // to prevent refetch on failed return code (404)
  });

  return { migrationData: data, isMigrationDataLoading: isFetching };
};

export default usePartnerMigration;
